import { createAppAsyncThunk } from '@/redux/create-app-thunk';
import { tryCatch } from '@/redux/thunks/shared/try-catch';
import { selectStoreId } from '@/redux/slices/root.slice';

export const deleteProductFromCart = createAppAsyncThunk(
  'deleteProductFromCart',
  async ({ partnumber }: { partnumber: string }, { rejectWithValue, getState, extra: { cartGateway } }) => {
    const storeId = selectStoreId(getState());
    const { data, error } = await tryCatch(cartGateway.deleteProductFromCart({ storeId, partnumber }));

    if (error) {
      return rejectWithValue({ message: 'errors.genericErrorMessage.main' });
    }

    return data;
  }
);
